import { LoginToWizardSuiteService } from "./loginToWizardSuite.service";
import { api } from "../../apiProvider";

export const loginToWizardSuiteAdapter: LoginToWizardSuiteService = async () => {
    const resp = await api.loginToWizardSuite();
    return resp.data;
};
